import api from "../../shared/services/api";
import { authenticate, isAuthenticated } from "../../shared/services/auth";
import endPoints from "../../shared/services/endPoints";
import { showToast } from "../slices/toastSlice";
import {
  fetchUnreadNotificationsCount,
  fetchUserNotifications,
  setUserProfile,
} from "../slices/userSlice";

const registerAction = (data, loading, navigate) => async (dispatch) => {
  loading(true);
  const res = await api("post", endPoints.REGISTER, data);

  if (res.success && res.data) {
    navigate("/auth/register-success");
  } else {
    dispatch(showToast({ severity: "error", summary: res.message }));
  }
  loading(false);
};

const loginAction = (data, loading, navigate) => async (dispatch) => {
  loading(true);
  const payload = {
    email: data?.email,
    password: data?.loginPassword
  }
  const res = await api("post", endPoints.LOGIN, payload);

  if (res.success && res.data) {
    // let user = {
    //   firstName: res.firstName,
    //   lastName: res.lastName,
    //   email: res.email,
    // };
    let token = res.data.token;
    authenticate(token, data.rememberMe, () => {
      dispatch(setUserProfile(res.data));
      if (isAuthenticated()) {
        navigate("/dashboard");
        dispatch(fetchUnreadNotificationsCount());
      } else {
        navigate("/auth/login");
      }
    });
  } else {
    dispatch(showToast({ type: "error", message: res.message }));
  }
  loading(false);
};

const requestOTPAction = (data, loading, next) => async (dispatch) => {
  loading(true);
  const res = await api("post", endPoints.REQUEST_OTP, {
    email: data.email,
    fullName: data.fullName,
    otpType: data.otpType,
  });

  if (res.success && res.data) {
    dispatch(showToast({ type: "success", message: res.message }));
    next();
  } else {
    dispatch(showToast({ type: "error", message: res.message }));
  }
  loading(false);
};

const verifyOTPAction = (data, loading, navigate) => async (dispatch) => {
  loading(true);
  const res = await api("post", endPoints.VERIFY_OTP, {
    email: data.email,
    otp: data.otp.toString(),
    otpType: data.otpType,
  });

  if (res.success && res.data) {
    if (data.otpType === 1) {
      const payload = {
        email: data.email,
        fullName: data.fullName,
        password: data.password,
        confirmPassword: data.confirmPassword,
      };
      dispatch(registerAction(payload, loading, navigate));
    } else {
      dispatch(showToast({ type: "success", message: res.message }));
      navigate("/auth/create-new-password", { state: data });
    }
  } else {
    dispatch(showToast({ type: "error", message: res.message }));
  }
  loading(false);
};

const forgotPasswordAction = (data, loading, navigate) => async (dispatch) => {
  loading(true);
  const res = await api("post", endPoints.FORGOT_PASSWORD, {
    email: data.email,
  });

  if (res.success && res.data) {
    dispatch(showToast({ type: "success", message: res.message }));
    navigate("/auth/verify-account", { state: data });
  } else {
    dispatch(showToast({ type: "error", message: res.message }));
  }
  loading(false);
};

const resetPasswordAction = (data, loading, navigate) => async (dispatch) => {
  loading(true);
  const res = await api("post", endPoints.RESET_PASSWORD, {
    email: data.email,
    password: data.password,
  });

  if (res.success) {
    dispatch(showToast({ type: "success", message: res.message }));
    navigate("/auth/password-reset-success", { replace: true, state: null });
  } else {
    dispatch(showToast({ type: "error", message: res.message }));
  }
  loading(false);
};

export {
  registerAction,
  loginAction,
  requestOTPAction,
  verifyOTPAction,
  forgotPasswordAction,
  resetPasswordAction,
};
